import axios from 'axios';

const initialState = {
    mobileAppAccess: {
        dietitian_user_id: null,
        patient_user_id: null,
        patient_id: null,
        patient_email: null,
        status: 'to_invite',
        app_version: null,
        settings: {
            displayedNutrients: [],
            notificationsEnabled: false,
            prescriptionsEnabled: false,
        },
        prescriptions: [],
    },
    excludedPrescriptionIds: [],
};

const state = Object.assign({}, initialState);

const getters = {
    mobileAppAccess: state => state.mobileAppAccess,
    excludedPrescriptionIds: state => state.excludedPrescriptionIds,
};

const actions = {
    async fetchMobileAppAccess({commit}, patientId) {
        await axios.get('/v2/mobile-app/' + patientId)
            .then((response) => {
                commit('setMobileAppAccess', response.data.data);
            }).catch((error) => {
            if (error.response && error.response.status === 404) {
                return;
            }
            throw error;
        });
    }
};

const mutations = {
    setMobileAppAccess: (state, mobileAppAccess) => (state.mobileAppAccess = mobileAppAccess),
    setExcludedPrescriptionIds: (state, excludedPrescriptionIds) => (state.excludedPrescriptionIds = excludedPrescriptionIds),
};

export default {
    state,
    getters,
    actions,
    mutations
};
